// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext, useMemo, Fragment, useState,
  useEffect} from 'react';
import cn from 'classnames';
import {Editor} from '../../../../../shared/editor/editor';
import {Button} from '../../../lib/button';
import {use_browser} from '../../../lib/use_browser';
import {Settings_context} from '../../../settings_ctx';
import {img_url} from '../../../ui/img_url';
import {open_store} from '../../../ui/install_btn';
import styles from './one_review.module.less';
// @ts-ignore
import {open_link} from '../../../install_util.js';

interface i_review {
    rating?: string;
    rating_text?: string;
    description?: string;
    author?: string;
    store_type?: string;
    hidden_for_middle?: boolean;
}

interface i_one_review {
    title?: string;
    description?: string;
    cta?: boolean;
    reviews?: i_review[];
}

interface i_one_review_props_editor {
    value: i_one_review;
    on_change: (new_value: i_one_review)=>void;
    on_cancel: ()=>void;
}

const Review = (props: i_review)=>{
  const {rating, rating_text, description, author, store_type,
    hidden_for_middle} = props;
  const {theme} = useContext(Settings_context);
  const get_title = useMemo(()=>{
    let title = 'hola on chrome webstore';
    if (store_type=='opera')
      title = 'hola on opera addons';
    if (store_type=='amazon')
      title = 'hola on amazon';
      return title;
  }, [store_type]);
  const get_store_img = useMemo(()=>{
    let store = 'chrome_webstore';
    if (store_type=='opera')
      store = 'opera';
    if (store_type=='amazon')
      store = 'amazon';
      return store;
  }, [store_type]);
  return <div className={cn(styles.one_review,
    hidden_for_middle && styles.hidden_for_middle)}>
    <div className={styles.review_platform}
      title={get_title}
      onClick={()=>open_link(store_type)}>
      <img src={img_url(`hola2023/review_${get_store_img}.svg`)}
        alt="chrome" className="lazyload"/>
      <p className={cn(theme.p3, theme.med)}><img alt="stars"
        className="lazyload"
        src={img_url(`hola2023/review_${get_store_img}_stars.svg`)}/>
        {rating}<span>|</span> {rating_text}
      </p>
    </div>
    <div className={styles.review_text}>
      <p className={cn(theme.p2)}>
        {description}
      </p>
      <div className={styles.name_and_pl}>
        <p className={theme.u4}>{author}</p>
        <p className={theme.u4}>{store_type}</p>
      </div>
    </div>
  </div>;
};

export const One_review = (props: i_one_review)=>{
    const {title: hero_title, description, cta, reviews = []} = props;
    const {theme} = useContext(Settings_context);
    const br = use_browser(['chrome', 'opera', 'edge']);
    const title = br.toUpperCase()[0] + br.substring(1);
    return <div className={styles.dont_take_block}>
      <img src={img_url('hola2023/stars.svg')} width={362} height={104}
        alt="stars" className="lazyload"/>
      <h3>{hero_title}</h3>
      <p className={cn(theme.u3)}>{description}</p>
      <div className={styles.reviews}>
        {Array.isArray(reviews) && reviews.map((r, i)=><Fragment key={i}>
          <Review {...r}/></Fragment>)}
      </div>
      {cta && <Button color={'black2023'}
        caption={`Add to ${title} - it's free`}
        on_click={()=>{
          open_store(false, br);
        }} size={'lg'}/>}
    </div>;
};

export const One_review_editor = (props: i_one_review_props_editor)=>{
  const [state, set_state] = useState<i_one_review>(()=>({
    title: props?.value?.title ?? '',
    description: props?.value?.description ?? '',
    cta: props?.value?.cta ?? false,
    reviews: props?.value?.reviews ?? [],
  }));
  const reviews = state.reviews || [];
  useEffect(()=>{
      set_state(c=>({...c, ...props.value}));
  }, [props.value]);
  return <Editor
    value={state}
    editors={[{key: 'title', label: 'Title', type: 'textarea'},
      {key: 'description', label: 'Description', type: 'textarea'},
      {key: 'cta', label: 'Call to action', type: 'boolean'}]}
    on_change={v=>set_state(v)}
    on_save={()=>props.on_change(state)}
    on_cancel={props.on_cancel}>
    <h4>Reviews: </h4>
    {reviews.map((li, i)=>
      <Fragment key={i}>
        <Editor
          title={li.author || `unknown`}
          key={i}
          value={li}
          editors={[
            {key: 'rating', label: 'rating', type: 'textarea'},
            {key: 'rating_text', label: 'Rating text', type: 'text'},
            {key: 'description', label: 'Review', type: 'textarea'},
            {key: 'author', label: 'Author', type: 'text'},
            {key: 'store_type', label: 'Store type(chrome/amazon/opera)',
              type: 'text'},
            {key: 'hidden_for_middle', label: 'Hidden review in tablet',
              type: 'boolean'},
          ]}
          on_change={v=>{
            const items_new = [...reviews];
            items_new[i] = v;
            set_state({...state, reviews: items_new});
          }}>
        </Editor>
        <Button caption={'Delete feature'} size={'xs'}
          on_click={()=>{
            set_state({...state, reviews: reviews
              .filter((_, index)=>index!==i)});
          }}/>
      </Fragment>
    )}
    <Button caption={'Add Review'} size={'xs'}
      on_click={()=>{
        set_state({...state, reviews: [...reviews, {
          rating: '',
          rating_text: '',
          description: '',
          author: '',
          store_type: '',
          hidden_for_middle: false,
        }]});
      }}/>
  </Editor>;
};
